import type { UseMutationOptions } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import type { AppendPatientConsentResponse } from "@/APIRequests/patientTyped";
import type { PatientConsent, PolicyConsentPayloadDTO } from "@/core/types";
import { getPatientProfile } from "@/redux/actions/auth";

import { appendPatientConsent } from "../queryFunctions/appendPatientConsent";

type Context = {
  previousConsents: PatientConsent[];
  updatedConsent: PatientConsent;
};

type UseAppendConsentMutationOptions = UseMutationOptions<
  AppendPatientConsentResponse,
  unknown,
  PolicyConsentPayloadDTO,
  Context
>;

export function useAppendConsent(options?: UseAppendConsentMutationOptions) {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: appendPatientConsent,
    onSuccess: () => {
      /** Refetch profile to redraw the updated view
       * This is a temporary solution until we move profile data to tanstack query
       */
      dispatch(getPatientProfile(true));
    },
    ...options,
  });
}
